import * as React from 'react'
import {useBlocker} from 'react-router'

import UnsavedChangesModal from '@frontrow/console/src/components/common/unsaved-changes/unsaved-changes-modal'

type Props = {
  when: boolean
}

// Navigation options for leaving a page once its changes are saved. The form can
// still differ from the saved record, where the server stores a value differently
// from how it was typed, so `when` alone would block this navigation.
export const afterSave = {state: {unsavedChangesSaved: true}}

export default function UnsavedChanges(props: Props): React.ReactElement {
  const {when} = props
  const blocker = useBlocker(
    ({nextLocation}) =>
      when &&
      (nextLocation.state as {unsavedChangesSaved?: boolean} | null)?.unsavedChangesSaved !== true
  )

  // `useBlocker` only sees navigations inside the app, not a reload or closing
  // the tab. The browser shows its own prompt for those.
  React.useEffect(() => {
    if (!when) return
    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault()
    }
    window.addEventListener('beforeunload', onBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload)
    }
  }, [when])

  const onLeave = () => {
    blocker.proceed?.()
  }

  const onStay = () => {
    blocker.reset?.()
  }

  return (
    <UnsavedChangesModal show={blocker.state === 'blocked'} onStay={onStay} onLeave={onLeave} />
  )
}
